<template>
  <div class="container ">
    <br />
    <div class="row">
      <div class="col-md-6">
        <div class="form-floating mb-3">
          <input type="text" class="form-control" id="siteName" v-model="siteName" />
          <label class="floating-label" for="siteName">單位名稱</label>
        </div>
        <div class="form-floating mb-3">
          <input type="text" class="form-control" id="userName" v-model="userName" />
          <label class="floating-label" for="userName">姓名</label>
        </div>
        <div class="form-floating mb-3">
          <input type="text" class="form-control" id="userAccount" v-model="userAccount" :class="{ 'is-invalid': invalidAccount }" @input="resetValidation" />
          <label class="floating-label" for="userAccount">受訓編號</label>
          <div v-if="invalidAccount && (userAccount != 'None')" class="invalid-feedback">
            受訓編號必須是 5 碼英數組合
          </div>
          <div v-if="checkAccount" class="invalid-feedback">
            該受訓編號已存在
          </div>
        </div>
        <div class="form-floating mb-3">
          <select class="form-control" id="userRole" v-model="userRole">
            <option value="">身分</option>
            <option value="admin">管理者</option>
            <option value="user">受訓人員</option>
          </select>
          <label class="form-label" for="userRole">身分</label>
        </div>
        <div class="form-floating mb-3">
          <input class="form-control" type="date" id="accountValidDate" v-model="accountValidDate" />
          <label class="form-label" for="accountValidDate">帳號有效日期</label>
        </div>
        <button class="btn btn-primary" @click="updateDo()">更新</button>

      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'DetailPage',
  data() {
    return {
      isDev: window.VUE_APP_Dev,
      PK: '',
      SK: '',
      siteName: '',
      userName: '',
      userAccount: '',
      userRole: '',
      accountValidDate: '',
      checkAccount: false,
      roles: ['管理者', '受訓人員'],

    };
  },
  beforeMount() {
    this.userLoginType = localStorage.getItem("userLoginType");
    const linecode = localStorage.getItem("linecode");
   
    if (this.isDev != '1') {
      if (!linecode) {
        this.$router.push({ name: "HomePage" });
      }
    }
  },
  created() {
    if (this.$route.query.PK) {
      this.PK = this.$route.query.PK;
    }
    if (this.$route.query.SK) {
      this.SK = this.$route.query.SK;
    }
    this.fetchData();

  },
  computed: {
    invalidAccount() {
      // 正則表達式匹配 5 碼英數組合
      return !/^[A-Za-z0-9]{5}$/.test(this.userAccount);
    },
  },
  mounted() {
    this.answerDateTime = this.convertTimestampToDate();
  },
  methods: {
    resetValidation() {
            this.checkAccount = false;
    },
    convertTimestampToDate() {
      return new Date(this.SK * 1000).toLocaleString();
    },
    goHomePage() {
      this.$router.push({
        path: '/'
      });
    },
    getCurrentDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      return `${year}/${month}/${day}`;
    },
    fetchData() {
      // 使用axios呼叫API，傳入PK和SK作為參數
      axios
        .get('https://147isrgvqd.execute-api.ap-northeast-1.amazonaws.com/getUserFoPKSK', {
          params: {
            PK: this.PK,
            SK: this.SK,
          },
        })
        .then((response) => {
          const data = response.data;
          this.userAccount = data.userAccount;
          this.userName = data.userName;
          this.userRole = data.userRole;
          this.siteName = data.siteName;
          this.accountValidDate = data.accountValidDate;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    updateDo() {
      const self = this;
      const data = {
        PK: this.PK,
        SK: this.SK,
        userAccount: this.userAccount,
        siteName: this.siteName,
        userName: this.userName,
        userRole: this.userRole,
        accountValidDate: this.accountValidDate

      };

      axios.post('https://147isrgvqd.execute-api.ap-northeast-1.amazonaws.com/updateUser', data)
        .then(response => {
          console.log(response.data);
          console.log("successfully!");
          if (response.data){
            if (response.data.Count >= 1){
              self.checkAccount = true;
            }else {
              self.checkAccount = false;
              self.$router.push({ name: "UserListPage" });
            }
          }else {
            self.checkAccount = false;
            self.$router.push({ name: "UserListPage" });
          }
          // alert("successfully!");
        })
        .catch(error => {
          console.error("save error" + error);
        });

    },

  },
};
</script>

<style>
@media (max-width: 768px) {
  table {
    width: 100%;
  }

  .table-responsive {
    overflow-x: auto;
  }
}

/* 在這裡放置您的 CSS 样式 */
body {
  font-family: 'Arial', sans-serif;
  background-color: #EFEDE6 !important;
  /* margin: 20px; */
}

.detailtable {
  width: 100%;
  background-color: #EFEDE6 !important;
  border-collapse: collapse;
  margin-bottom: 20px;
}

.info-box {
  padding: 10px;
  margin-bottom: 20px;
}

.detailtable th,
.detailtable td {
  background-color: #EFEDE6 !important;
  padding: 10px;
  text-align: center;
}

.detailtable th {
  background-color: #EFEDE6 !important;
  font-weight: bold;
}

.table-bordered {
  border: 1px solid #c5c3be !important;
  /* 邊框使用暖灰色 */

}

.feedback-header {
  font-size: 1.1em;
  font-weight: 800;
  margin-bottom: 10px;
}

.bd-code-snippet {
  /* width: 200mm !important; */
  border-width: 1px;
  border-radius: var(--bs-border-radius);
  border: solid var(--bs-border-color);
}

.btn-primary {
  background-color: #CC785C !important;
  /* 按鈕使用銅紅色 */
  border-color: #D3A17E !important;
  /* 按鈕邊框使用淡粉棕色 */
  color: #EFEDE1 !important;
  /* 按鈕文字使用象牙色 */
}

.btn-primary:hover {
  background-color: #D3A17E !important;
  /* 鼠標懸停時的按鈕背景色 */
  border-color: #CC785C !important;
  /* 鼠標懸停時的按鈕邊框色 */
}

.is-invalid {
  border-color: #dc3545;
}

.invalid-feedback {
  display: block;
  color: #dc3545;
}
</style>